import React, { Component, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { updateHeaderInfo, getUserDetails } from "../actions";
import { CopyrightWidget, LoadingCard } from "../components";
import { APPVERSION, APPID, createMarkup, remoteURL } from "../common";
import { Divider, Typography, Grid } from "@material-ui/core";
import { deviceData, setContainer } from "../common";
import { isBrowser } from 'react-device-detect';

import "../styles/masterStyles.css";

class CMEInfo extends Component {
    state = {
        appversion: APPVERSION, 
        appid: APPID,
        loading: true,
        cme: null,
        year: 1901,
        thisyear: 1900
    }

    objChecked = (data) => {
        if (typeof data === 'object') return true;
        else return false;
    }
x
    componentDidMount = async () => {
        let _d = new Date();
        let _y = _d.getFullYear();
        let _ty = _y;

        const { mcid, key } = this.props.auth_feedback;
        this.props.getUserDetails(mcid, key, deviceData(this.props.location, 'navigate'));

        if (this.objChecked(this.props.location.state)) {
            if (this.objChecked(this.props.location.state.cme)) {
                if (typeof this.props.location.state.cme.year === 'number') {
                    _ty = Number(this.props.location.state.cme.year);
                }
            } 
        }

        await this.setState({ 
            ...this.state,
            cme: this.props.location.state.cme,
            year: _y,
            thisyear: _ty,
        }); 

        return this.props.updateHeaderInfo({
            route:"/cmeinfo", 
            name: "SASP", 
            iconTwo: 'menu', 
            iconOne: 'home',
            color: "#00567a"
        });
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevState.cme !== this.state.cme) {
            this.setState({ ...this.state, loading: false });
        }

        if (prevProps.location.cme !== this.props.location.cme) {
            this.setState({ ...this.state, loading: true, cme: this.props.location.state.cme });
        }
    }

    render() {
        if (this.state.loading) {
            return (
                <LoadingCard text="Loading CME Information..."/>
            );
        } else {
            return (
                <>
                    <div className="aua-overflow anchor" style={setContainer(isBrowser)}>
                        <div style={{ padding: "8px 0 16px"}} >
                            {/* <Typography className="homeDividerText">SASP {this.state.cme.title} CME Info</Typography>
                            <Divider className="TestsDivider" /> */}

                            <div className="width100 padding-bottom-24">
                                <div className="margin-bottom-8 width100" dangerouslySetInnerHTML={createMarkup(this.state.cme.CMEContent)}/>
                            </div>
                        </div>

                        {this.state.cme.programID === 'SASP21'
                            ? (
                                <>
                                    <Typography className="homeDividerText" >
                                        Education Council Disclosures
                                    </Typography>

                                    <div className="width100 margin-bottom-16 margin-top-8">
                                        
                                        <Link className="text-blue text-bold margin-bottom-8" onClick={() => remoteURL('https://University.auanet.org/sasp/resources/education_council_disclosures_2021.pdf')} >
                                            
                                            View Disclosures
                                        </Link>

                                        <Divider className="margin-top-8" />
                                    </div>

                                    <Typography className="homeDividerText" >
                                        COI Review Work Group Disclosures
                                    </Typography>

                                    <div className="width100 margin-bottom-16 margin-top-8">
                                        <Link className="text-blue text-bold margin-bottom-8" onClick={() => remoteURL('https://University.auanet.org/sasp/resources/coi_review_disclosures_2021.pdf')} >
                                            
                                            View Disclosures
                                        </Link>

                                        <Divider className="margin-top-8" />
                                    </div>

                                    <Typography className="homeDividerText" >
                                        ABU Examination Committee Disclosures
                                    </Typography>

                                    <div className="width100 margin-bottom-16 margin-top-8">
                                        <Link className="text-blue text-bold margin-bottom-8" onClick={() => remoteURL('https://University.auanet.org/sasp/resources/abu_exam_committee_2021.pdf')} >
                                            View Disclosures
                                        </Link>

                                        <Divider className="margin-top-8" />
                                    </div>
                                </>
                            ) : null
                        }

                        {this.state.cme.programID === 'SASP22'
                            ? (
                                <>
                                    <Typography className="homeDividerText" >
                                        Disclosures
                                    </Typography>

                                    <div className="width100 margin-bottom-16 margin-top-8">
                                        
                                        <Link className="text-blue text-bold margin-bottom-8" onClick={() => remoteURL('https://University.auanet.org/sasp/resources/2022_SASP_CME_Disclosures.pdf')} >
                                            View Disclosures                                
                                        </Link>

                                        <Divider className="margin-top-8" />
                                    </div>
                                </>
                            ) : null
                        }
                    
                        <CopyrightWidget
                            begin={this.state.thisyear}
                            year={this.state.year}
                            textAlign={'center'}
                            className="width100 margin-top-48s margin-bottom-48" 
                        />
                    </div>
                </>
            );
        }
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details } = state.auth;

    return {
        auth_feedback,
        user_details,
    };
};

const CMEInfoScreen = connect(mapStateToProps, { updateHeaderInfo, getUserDetails })(
    CMEInfo
);

export { CMEInfoScreen };
